import React, { useState } from "react";
import Bg from "../../../images/shapes/shape_title_under_line.svg";
import shape1 from "../../../images/shapes/shape_space_4.svg";
import shape2 from "../../../images/shapes/shape_angle_3.webp";
import { Accordion, AccordionBody, AccordionHeader, AccordionItem } from "reactstrap";
import faqItems from "../../../api/faq";

const FaqSection = () => {
  const [open, setOpen] = useState("1");

  return (
    <section className="faq_section section_decoration" aria-labelledby="faq-heading">
      <div className="container">
        <div className="heading_block text-center">
          <div className="heading_focus_text has_underline d-inline-flex" style={{ backgroundImage: `url(${Bg})` }}>
            Frequently Asked Questions
          </div>
          <h2 id="faq-heading" className="heading_text mb-0">
            Answers about <mark>our services</mark>
          </h2>
        </div>

        <div className="faq_accordion accordion" id="faq_accordion">
          <Accordion open={open} toggle={(id) => setOpen(open === id ? "" : id)} className="accordion" id="service_process_faq">
            {faqItems.map((item, index) => {
              const id = String(index + 1);
              return (
                <AccordionItem className="accordion-item" key={item.question}>
                  <AccordionHeader targetId={id}>{item.question}</AccordionHeader>
                  <AccordionBody accordionId={id} className="acc_body">
                    <p>{item.answer}</p>
                  </AccordionBody>
                </AccordionItem>
              );
            })}
          </Accordion>
        </div>
      </div>
      <div className="decoration_item shape_image_1"><img src={shape1} alt="" aria-hidden="true" /></div>
      <div className="decoration_item shape_image_2"><img src={shape2} alt="" aria-hidden="true" /></div>
    </section>
  );
};

export default FaqSection;
